import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "create-tag"
}

import { onMounted, ref } from 'vue'
import { ElIcon, ElInput, ElButton, ElPagination, ElEmpty, ElMessageBox, ElLoading } from 'element-plus'
import { useSdkStore } from '@/stores/sdk'
import { makeCustomizedImages } from '@/api/affairs'
import { useMiscStore } from "@/stores/misc";

export default /*@__PURE__*/_defineComponent({
  __name: 'createTag',
  setup(__props) {

const miscStore = useMiscStore()
const sdkStore = useSdkStore()
const showCreateTag = ref(false)
const desginsdk = sdkStore.getSdk()
onMounted(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const admin_id = urlParams.get('design_admin_id')
    if (admin_id) {
        showCreateTag.value = true
    }
})
const createimage = () => {
    const loadingInstance = ElLoading.service({
        lock: true,
        text: '生成中...',
        background: 'rgba(0, 0, 0, 0.2)'
    })
    ElMessageBox.confirm(
        '确定要生成生产图吗？',
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    ).then(async () => {
        desginsdk.designOpt.saveTemplate()
        const urlParams = new URLSearchParams(window.location.search)
        const id = urlParams.get('id') as string
        const admin_id = urlParams.get('design_admin_id') || '0'
        let params = {
            id: id,
            admin_id: admin_id,
            json_url: miscStore.getOssURL(),
        }
        setTimeout(async () => {
            await makeCustomizedImages(params)
            loadingInstance.close()
            window.close()
        }, 1000)
    }).catch(() => {
        loadingInstance.close()
    })
}

return (_ctx: any,_cache: any) => {
  return (showCreateTag.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElButton), {
          type: "primary",
          size: "large",
          onClick: createimage,
          style: {"background-color":"#2a66ff"}
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("生成生产图", -1)
          ]))]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})